import MembershipAgreementPage from './MembershipAgreementPage';

export default MembershipAgreementPage;


// WEBPACK FOOTER //
// ./src/components/MembershipAgreementPage/index.jsx